'use client';

import { isBrowser } from '@backyard-ui/utils';
import { datadogRum } from '@datadog/browser-rum';

import { beforeSend } from './before-send';

const DATADOG_RUM_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_FLIP_DATADOG_RUM_ENABLED === 'true';
const DATADOG_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const DATADOG_APPLICATION_ID = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const DATADOG_ENV_NAME = process.env.NEXT_PUBLIC_DATADOG_ENV_NAME;
const DATADOG_VERSION = process.env.NEXT_PUBLIC_DATADOG_VERSION;
const DATADOG_SESSION_REPLAY_SAMPLE_RATE = 0;
const BASE_URL = process.env.NEXT_PUBLIC_ENDPOINT_LEROY;

const NEXT_PUBLIC_DATADOG_TRACE_SAMPLE_RATE = Number(
  process.env.NEXT_PUBLIC_DATADOG_TRACE_SAMPLE_RATE ?? 8
);

const DATADOG_SESSION_SAMPLE_RATE = Number(
  process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE ?? 10
);

const initRumDatadog = () => {
  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'lmbr-ameno',
    env: DATADOG_ENV_NAME,
    sessionSampleRate: DATADOG_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: DATADOG_SESSION_REPLAY_SAMPLE_RATE,
    traceSampleRate: NEXT_PUBLIC_DATADOG_TRACE_SAMPLE_RATE,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    version: DATADOG_VERSION,
    allowedTracingUrls: [{ match: BASE_URL, propagatorTypes: ['datadog'] }],
    beforeSend,
  });
};

if (DATADOG_RUM_ENABLED && isBrowser) {
  initRumDatadog();
}
